define.alias("shared/components/shared/sourceless-trial/confirmation-modal", "settings/components/shared/sourceless-trial/confirmation-modal");